import { ValueType } from "@hypertune/sdk/src/shared/types";

export default function isNumericValueType(valueType: ValueType): boolean {
  return (
    valueType.type === "IntValueType" || valueType.type === "FloatValueType"
  );
}
